import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { useCountry } from "src/client/js/view/hooks";
import { localiseUrlII } from "src/common/utils/format-localised-url";
import { MinusIcon, PlusIcon } from "../../SVGs";

const ShopNavigationMobileItem = ({ title, columns, active, handleClick }) => {
  const country = useCountry();
  const AccordionButtonStateIcon = active ? MinusIcon : PlusIcon;

  return (
    <li className="ShopNavigationMobile__nav-item">
      <button
        active={active}
        onClick={handleClick}
        className={cx("ShopNavigationMobile__accordion-button", {
          "ShopNavigationMobile__accordion-button--clicked": active,
        })}
      >
        <span className="ShopNavigationMobile__text">{title}</span>
        <AccordionButtonStateIcon />
      </button>
      <div
        className={cx("ShopNavigationMobile__nav-container", {
          "ShopNavigationMobile__nav-container--active": active,
        })}
      >
        {columns?.map(({ id, items }) => {
          return (
            <ul key={id} className="ShopNavigationMobile__secondary-list">
              {items.map(({ navLinkLabel, navLinkUrl }) => {
                return (
                  <li
                    key={navLinkLabel}
                    className="ShopNavigationMobile__link-item"
                  >
                    <a
                      className="ShopNavigationMobile__nav-link"
                      href={localiseUrlII(country, navLinkUrl)}
                    >
                      {navLinkLabel}
                    </a>
                  </li>
                );
              })}
            </ul>
          );
        })}
      </div>
    </li>
  );
};

ShopNavigationMobileItem.propTypes = {
  title: PropTypes.string,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          navLinkLabel: PropTypes.string.isRequired,
          navLinkUrl: PropTypes.string.isRequired,
        })
      ),
    })
  ),
  active: PropTypes.bool,
  handleClick: PropTypes.func,
};

export default ShopNavigationMobileItem;
